import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useUserContextController } from '../../context/UserContext';
import ProfilePage from '../profile';
import UserAccessPage from '../access-control/userAccessPage';
import IntegrationsPage from './IntegrationsPage';
import UsagePage from './UsagePage';
import SettingsSidebar from '../../components/SideBar/SettingsSidebar';
import WebTopbar from '../../components/topbar/WebTopbar';
import { SettingsTab } from '../../types/settings';
import { TOPBAR_HEIGHT } from '../../constants/layout';

const SettingsPage: React.FC = () => {
  const [userContext] = useUserContextController();
  const [searchParams] = useSearchParams();
  const { user, company } = userContext;
  const [selectedTab, setSelectedTab] = useState<SettingsTab>(
    SettingsTab.PROFILE
  );

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab === 'integrations' && user?.isAdmin) {
      setSelectedTab(SettingsTab.INTEGRATIONS);
    } else if (tab === 'usage') {
      setSelectedTab(SettingsTab.USAGE);
    }
  }, [searchParams, user?.isAdmin]);

  if (!user || !company) {
    return <Navigate to="home" replace />;
  }

  const getSettingsContent = () => {
    if (selectedTab === SettingsTab.PROFILE) {
      return <ProfilePage />;
    } else if (selectedTab === SettingsTab.ACCESS) {
      return <UserAccessPage />;
    } else if (selectedTab === SettingsTab.INTEGRATIONS) {
      return <IntegrationsPage />;
    } else if (selectedTab === SettingsTab.USAGE) {
      return <UsagePage />;
    }
  };

  return (
    <>
      <WebTopbar />
      <Box
        sx={{
          display: 'flex',
          height: `calc(100vh - ${TOPBAR_HEIGHT}px)`,
          backgroundColor: '#f5f5f5'
        }}
      >
        {/* Sidebar */}
        <SettingsSidebar
          selectedTab={selectedTab}
          onTabChange={setSelectedTab}
        />

        {/* Main Content */}
        <Box
          sx={{
            flex: 1,
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          {getSettingsContent()}
        </Box>
      </Box>
    </>
  );
};

export default SettingsPage;
